/**
 * Constants for parts of translation.
 */

export var CONTEXT_MENU_ITEMS_NAMESPACE = 'ContextMenu:items';
var CM_ALIAS = CONTEXT_MENU_ITEMS_NAMESPACE;
export var CONTEXTMENU_ITEMS_NO_ITEMS = "".concat(CM_ALIAS, ".noItems");
export var CONTEXTMENU_ITEMS_ROW_ABOVE = "".concat(CM_ALIAS, ".insertRowAbove");
export var CONTEXTMENU_ITEMS_ROW_BELOW = "".concat(CM_ALIAS, ".insertRowBelow");
export var CONTEXTMENU_ITEMS_INSERT_LEFT = "".concat(CM_ALIAS, ".insertColumnOnTheLeft");
export var CONTEXTMENU_ITEMS_INSERT_RIGHT = "".concat(CM_ALIAS, ".insertColumnOnTheRight");
export var CONTEXTMENU_ITEMS_REMOVE_ROW = "".concat(CM_ALIAS, ".removeRow");
export var CONTEXTMENU_ITEMS_REMOVE_COLUMN = "".concat(CM_ALIAS, ".removeColumn");
export var CONTEXTMENU_ITEMS_UNDO = "".concat(CM_ALIAS, ".undo");
export var CONTEXTMENU_ITEMS_REDO = "".concat(CM_ALIAS, ".redo");
export var CONTEXTMENU_ITEMS_READ_ONLY = "".concat(CM_ALIAS, ".readOnly");
export var CONTEXTMENU_ITEMS_CLEAR_COLUMN = "".concat(CM_ALIAS, ".clearColumn");
export var CONTEXTMENU_ITEMS_COPY = "".concat(CM_ALIAS, ".copy");
export var CONTEXTMENU_ITEMS_COPY_WITH_COLUMN_HEADERS = "".concat(CM_ALIAS, ".copyWithHeaders");
export var CONTEXTMENU_ITEMS_COPY_WITH_COLUMN_GROUP_HEADERS = "".concat(CM_ALIAS, ".copyWithGroupHeaders");
export var CONTEXTMENU_ITEMS_COPY_COLUMN_HEADERS_ONLY = "".concat(CM_ALIAS, ".copyHeadersOnly");
export var CONTEXTMENU_ITEMS_CUT = "".concat(CM_ALIAS, ".cut");
export var CONTEXTMENU_ITEMS_FREEZE_COLUMN = "".concat(CM_ALIAS, ".freezeColumn");
export var CONTEXTMENU_ITEMS_UNFREEZE_COLUMN = "".concat(CM_ALIAS, ".unfreezeColumn");
export var CONTEXTMENU_ITEMS_MERGE_CELLS = "".concat(CM_ALIAS, ".mergeCells");
export var CONTEXTMENU_ITEMS_UNMERGE_CELLS = "".concat(CM_ALIAS, ".unmergeCells");
export var CONTEXTMENU_ITEMS_ADD_COMMENT = "".concat(CM_ALIAS, ".addComment");
export var CONTEXTMENU_ITEMS_EDIT_COMMENT = "".concat(CM_ALIAS, ".editComment");
export var CONTEXTMENU_ITEMS_REMOVE_COMMENT = "".concat(CM_ALIAS, ".removeComment");
export var CONTEXTMENU_ITEMS_READ_ONLY_COMMENT = "".concat(CM_ALIAS, ".readOnlyComment");
export var CONTEXTMENU_ITEMS_ALIGNMENT = "".concat(CM_ALIAS, ".align");
export var CONTEXTMENU_ITEMS_ALIGNMENT_LEFT = "".concat(CM_ALIAS, ".align.left");
export var CONTEXTMENU_ITEMS_ALIGNMENT_CENTER = "".concat(CM_ALIAS, ".align.center");
export var CONTEXTMENU_ITEMS_ALIGNMENT_RIGHT = "".concat(CM_ALIAS, ".align.right");
export var CONTEXTMENU_ITEMS_ALIGNMENT_JUSTIFY = "".concat(CM_ALIAS, ".align.justify");
export var CONTEXTMENU_ITEMS_ALIGNMENT_TOP = "".concat(CM_ALIAS, ".align.top");
export var CONTEXTMENU_ITEMS_ALIGNMENT_MIDDLE = "".concat(CM_ALIAS, ".align.middle");
export var CONTEXTMENU_ITEMS_ALIGNMENT_BOTTOM = "".concat(CM_ALIAS, ".align.bottom");
export var CONTEXTMENU_ITEMS_BORDERS = "".concat(CM_ALIAS, ".borders");
export var CONTEXTMENU_ITEMS_BORDERS_TOP = "".concat(CM_ALIAS, ".borders.top");
export var CONTEXTMENU_ITEMS_BORDERS_RIGHT = "".concat(CM_ALIAS, ".borders.right");
export var CONTEXTMENU_ITEMS_BORDERS_BOTTOM = "".concat(CM_ALIAS, ".borders.bottom");
export var CONTEXTMENU_ITEMS_BORDERS_LEFT = "".concat(CM_ALIAS, ".borders.left");
export var CONTEXTMENU_ITEMS_REMOVE_BORDERS = "".concat(CM_ALIAS, ".borders.remove");
export var CONTEXTMENU_ITEMS_NESTED_ROWS_INSERT_CHILD = "".concat(CM_ALIAS, ".nestedHeaders.insertChildRow"); // eslint-disable-line max-len
export var CONTEXTMENU_ITEMS_NESTED_ROWS_DETACH_CHILD = "".concat(CM_ALIAS, ".nestedHeaders.detachFromParent"); // eslint-disable-line max-len

export var CONTEXTMENU_ITEMS_HIDE_COLUMN = "".concat(CM_ALIAS, ".hideColumn");
export var CONTEXTMENU_ITEMS_SHOW_COLUMN = "".concat(CM_ALIAS, ".showColumn");
export var CONTEXTMENU_ITEMS_HIDE_ROW = "".concat(CM_ALIAS, ".hideRow");
export var CONTEXTMENU_ITEMS_SHOW_ROW = "".concat(CM_ALIAS, ".showRow");
export var FILTERS_NAMESPACE = 'Filters:';
export var FILTERS_CONDITIONS_NAMESPACE = "".concat(FILTERS_NAMESPACE, "conditions");
export var FILTERS_CONDITIONS_NONE = "".concat(FILTERS_CONDITIONS_NAMESPACE, ".none");
export var FILTERS_CONDITIONS_EMPTY = "".concat(FILTERS_CONDITIONS_NAMESPACE, ".isEmpty");
export var FILTERS_CONDITIONS_NOT_EMPTY = "".concat(FILTERS_CONDITIONS_NAMESPACE, ".isNotEmpty");
export var FILTERS_CONDITIONS_EQUAL = "".concat(FILTERS_CONDITIONS_NAMESPACE, ".isEqualTo");
export var FILTERS_CONDITIONS_NOT_EQUAL = "".concat(FILTERS_CONDITIONS_NAMESPACE, ".isNotEqualTo");
export var FILTERS_CONDITIONS_BEGINS_WITH = "".concat(FILTERS_CONDITIONS_NAMESPACE, ".beginsWith");
export var FILTERS_CONDITIONS_ENDS_WITH = "".concat(FILTERS_CONDITIONS_NAMESPACE, ".endsWith");
export var FILTERS_CONDITIONS_CONTAINS = "".concat(FILTERS_CONDITIONS_NAMESPACE, ".contains");
export var FILTERS_CONDITIONS_NOT_CONTAIN = "".concat(FILTERS_CONDITIONS_NAMESPACE, ".doesNotContain");
export var FILTERS_CONDITIONS_BY_VALUE = "".concat(FILTERS_CONDITIONS_NAMESPACE, ".byValue");
export var FILTERS_CONDITIONS_GREATER_THAN = "".concat(FILTERS_CONDITIONS_NAMESPACE, ".greaterThan");
export var FILTERS_CONDITIONS_GREATER_THAN_OR_EQUAL = "".concat(FILTERS_CONDITIONS_NAMESPACE, ".greaterThanOrEqualTo");
export var FILTERS_CONDITIONS_LESS_THAN = "".concat(FILTERS_CONDITIONS_NAMESPACE, ".lessThan");
export var FILTERS_CONDITIONS_LESS_THAN_OR_EQUAL = "".concat(FILTERS_CONDITIONS_NAMESPACE, ".lessThanOrEqualTo");
export var FILTERS_CONDITIONS_BETWEEN = "".concat(FILTERS_CONDITIONS_NAMESPACE, ".isBetween");
export var FILTERS_CONDITIONS_NOT_BETWEEN = "".concat(FILTERS_CONDITIONS_NAMESPACE, ".isNotBetween");
export var FILTERS_CONDITIONS_AFTER = "".concat(FILTERS_CONDITIONS_NAMESPACE, ".after");
export var FILTERS_CONDITIONS_BEFORE = "".concat(FILTERS_CONDITIONS_NAMESPACE, ".before");
export var FILTERS_CONDITIONS_TODAY = "".concat(FILTERS_CONDITIONS_NAMESPACE, ".today");
export var FILTERS_CONDITIONS_TOMORROW = "".concat(FILTERS_CONDITIONS_NAMESPACE, ".tomorrow");
export var FILTERS_CONDITIONS_YESTERDAY = "".concat(FILTERS_CONDITIONS_NAMESPACE, ".yesterday");
export var FILTERS_DIVS_FILTER_BY_CONDITION = "".concat(FILTERS_NAMESPACE, "labels.filterByCondition");
export var FILTERS_DIVS_FILTER_BY_VALUE = "".concat(FILTERS_NAMESPACE, "labels.filterByValue");
export var FILTERS_LABELS_CONJUNCTION = "".concat(FILTERS_NAMESPACE, "labels.conjunction");
export var FILTERS_LABELS_DISJUNCTION = "".concat(FILTERS_NAMESPACE, "labels.disjunction");
export var FILTERS_VALUES_BLANK_CELLS = "".concat(FILTERS_NAMESPACE, "values.blankCells");
export var FILTERS_BUTTONS_SELECT_ALL = "".concat(FILTERS_NAMESPACE, "buttons.selectAll");
export var FILTERS_BUTTONS_CLEAR = "".concat(FILTERS_NAMESPACE, "buttons.clear");
export var FILTERS_BUTTONS_OK = "".concat(FILTERS_NAMESPACE, "buttons.ok");
export var FILTERS_BUTTONS_CANCEL = "".concat(FILTERS_NAMESPACE, "buttons.cancel");
export var FILTERS_BUTTONS_PLACEHOLDER_SEARCH = "".concat(FILTERS_NAMESPACE, "buttons.placeholder.search");
export var FILTERS_BUTTONS_PLACEHOLDER_VALUE = "".concat(FILTERS_NAMESPACE, "buttons.placeholder.value");
export var FILTERS_BUTTONS_PLACEHOLDER_SECOND_VALUE = "".concat(FILTERS_NAMESPACE, "buttons.placeholder.secondValue");


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/i18n/constants.mjs
// module id = 37
// module chunks = 1